import { CloseBoxMultipleIcon } from './CloseBoxMultipleIcon';

/**
 * author: Michael Richins
 * id 63F3E252-98F2-4851-A887-E99FACD6B280
 * name close-box-multiple
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/close-box-multiple.svg
 * tags
 * - Form 
 */
export const MultiplyBoxesIcon = CloseBoxMultipleIcon;
export default MultiplyBoxesIcon